import React from "react";
import "./accountDeletion.css";

const AccountDeletion = () => {
  return (
    <div className="account-deletion-container">
      <h1 className="title">ACCOUNT DELETION</h1>
      <div className="step">
        <span>
          To delete your account, first log in to the B-Scent application.
        </span>
        <img src={require("./images/login.png")} alt="Login" />
      </div>
      <div className="step">
        <span>
          Then click on the icon to access the Settings Menu, available in the
          bottom right corner of the application.
        </span>
        <img src={require("./images/icone.png")} alt="Settings" />
      </div>
      <div className="step">
        <span>Then click on your name to access your information.</span>
        <img src={require("./images/login21.png")} alt="Settings" />
      </div>
      <div className="step">
        <span>
          Finally, click the DELETE ACCOUNT button and follow the instructions
          to complete the deletion.
        </span>
        <div className="container">
          <div className="item">
            <img src={require("./images/login31.png")} alt="Delete" />
          </div>
          <div className="item">
            <img src={require("./images/login32.png")} alt="Delete" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountDeletion;
